import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M22 0C9.848 0 0 9.848 0 22s9.848 22 22 22 22-9.848 22-22S34.152 0 22 0Zm0 40.33C11.877 40.33 3.67 32.123 3.67 22 3.67 11.877 11.877 3.67 22 3.67c10.123 0 18.33 8.207 18.33 18.33 0 10.123-8.207 18.33-18.33 18.33Zm1.83-33h-3.67V22l8.25 8.25 2.75-2.75-7.33-7.33V7.33Z",
      fill: "#0F0D37"
    }, null, -1)
  ]))]))
}
export default { render: render }